import React from "react";
import { Box, Button, Modal } from "@mui/material";
import { getPropertiesByPortfolioId } from "../../../app/util";
import EllipsisWithTooltip from "../PricingModal1/EllipsisWithTooltip";

const PortfolioDeleteModal = ({
    showDeletePopup,
    closeDeletePopup,
    confirmDeletePortfolio,
    portfolioId,
    portfolios
}) => {
    let selected_portfolio = getPropertiesByPortfolioId(portfolios, portfolioId, "selected_portfolio");
    let portfolioName = selected_portfolio?.name;
    return (
        <Modal
            open={showDeletePopup}
            onClose={closeDeletePopup}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box className="pricing-seasons-popup" sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '468px',
                //height: '200px',
                bgcolor: '#fff',
                borderRadius: '8px',
            }}>
                <Box className="popup-container">
                    <div className='popup-close-icon'>
                        <svg onClick={closeDeletePopup} xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#606060" viewBox="0 0 256 256"><path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"></path></svg>
                    </div>

                    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="#C92A2A" viewBox="0 0 256 256"><path d="M216,48H176V40a24,24,0,0,0-24-24H104A24,24,0,0,0,80,40v8H40a8,8,0,0,0,0,16h8V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM96,40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96Zm96,168H64V64H192ZM112,104v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm48,0v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Z"></path></svg>
                    <Box>
                        <div className='popup-title'> <EllipsisWithTooltip width={400} text={"Are You Sure You Want to Delete "+portfolioName+"?"} /> </div>
                        <div className='popup-msg'>This Action Can't Be Undone.</div>
                    </Box>
                    <Box className="action-buttons">
                        <Button className='btn-group navigate-cancel-button' onClick={closeDeletePopup}>Cancel</Button>
                        <Button className='btn-group navigate-save-button' sx={{ background: "#C92A2A !important" }} onClick={confirmDeletePortfolio}>Delete</Button>
                    </Box>
                </Box>
            </Box>
        </Modal>
    );
};

export default PortfolioDeleteModal;